module.exports = __webpack_public_path__ + "static/media/ecommerce-illus-mob.0ed2732f.png";